import * as types from './actionTypes'

export const fetchLinkedOptions = (id) => ({
    type: types.LINKED_OPTIONS_FETCH,
    id
})

export const fetchLinkedOptionsSuccess = (data, id) => ({
    type: types.LINKED_OPTIONS_SUCCESS,
    data,
    id
})

export const fetchLinkedOptionsFailed = () => ({
    type: types.LINKED_OPTIONS_FAILED
})

export const fetchFilterOptions = (originEntity, foreignEntity) => ({
	type: types.FILTER_OPTIONS_FETCH,
	originEntity,
	foreignEntity
})

export const fetchFilterOptionsSuccess = (filters) => ({
	type: types.FILTER_OPTIONS_SUCCESS,
	filters
})

export const fetchFilterOptionsFailed = () => ({
	type: types.FILTER_OPTIONS_FAILED
})

export const resetFilterOptions = () => ({
	type: types.FILTER_OPTIONS_RESET
})
